var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-loading-component',{attrs:{"user-uid":_vm.userUid},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var userLoading = ref.userLoading;
var user = ref.user;
return [_c('pu-skeleton',{attrs:{"loading":userLoading,"height":"1rem","width":"10rem"}},[(user)?[(_vm.linked && user.uid)?_c('user-link',_vm._b({staticClass:"hover-underline"},'user-link',user,false),[_vm._v(" "+_vm._s(user.displayName)+" ")]):[_c('span',[_vm._v(_vm._s(user.displayName))])]]:_vm._e()],2)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }